<template>
  <img :src="require(`@/assets/logo/logo.svg`)" width="140px" />
</template>

<script>
export default {}
</script>
